import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./SaveHyperOnAndroid.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { usePwaContext } from "../../../context/pwa-context";
import { setStoredPwaInstallOrigin } from "../../../utils/storage";
import { SaveHyperModalProps } from "../types";
import ImageAddToHome from "../../../images/add-to-home.png";

export default function SaveHyperOnAndroid({
  isOpen,
  onClose,
}: SaveHyperModalProps) {
  const { t } = useTranslation("common");
  const { promptUserToInstall } = usePwaContext();

  const handleSaveHyper = () => {
    const { pathname } = window.location;
    promptUserToInstall();
    setStoredPwaInstallOrigin(pathname);
    onClose();
  };

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass="SaveHyperOnAndroidModal"
    >
      <Stack gap={4}>
        <Stack className="SaveHyperOnAndroidMainContent">
          <Image
            src={ImageAddToHome}
            alt="Add to home screen"
            height={80}
            width={80}
          />
          <p className="MainCopy">
            {t("notifications.add_sigma_games_to_home_screen")}
          </p>
          <Stack gap={2}>
            <p className="SubCopy">
              {t("notifications.get_back_into_the_action_in_one_tap")}
              {t("punctuations.full_stop")}
            </p>
            <p className="AppSize">{t("notifications.size_1_mb")}</p>
          </Stack>
        </Stack>

        <PrimaryActionButton
          text={t("notifications.add_to_home_screen")}
          onClick={handleSaveHyper}
        />
      </Stack>
    </BottomDrawer>
  );
}
